import { ref, Ref } from '@nuxtjs/composition-api';

export type Filters = { [key in string]: string[] };

export interface UseFilters {
  filters: Ref<Filters>;
  add: (key: string, value: string) => void;
  remove: (key: string, value: string) => void;
  clear: () => void;
}

export const useFilters = <T extends Filters>(initialFilters?: T): UseFilters => {
  const filters = ref<Filters>(initialFilters || ({} as T));

  const add = (key: string, value: string): void => {
    const currentFilterValue = filters.value[key] || [];
    if (currentFilterValue?.includes(value)) {
      return;
    }

    filters.value = {
      ...filters.value,
      [key]: [...currentFilterValue, value],
    };
  };

  const remove = (key: string, value: string): void => {
    const currentFilterValue = filters.value[key];
    if (!currentFilterValue) {
      return;
    }
    if (currentFilterValue.length > 1) {
      filters.value = {
        ...filters.value,
        [key]: currentFilterValue.filter(v => v !== value),
      };
    } else {
      const { [key]: _, ...rest } = filters.value;
      filters.value = rest;
    }
  };

  const clear = (): void => {
    filters.value = {};
  };

  return { filters, add, remove, clear };
};
